module.exports = __webpack_public_path__ + "static/video_poster_04.fc51b285.png";